<div [formGroup]="group">
    <app-textarea-input
        formControlName="value"
        [hasMarginDouble]="true"
        [hasMargin]="false"
        width="100%"
        [label]="question | questionTitle"
        [id]="question.id"
        [showErrors]="!question.invalidMessage"
        [minLengthCounter]="minLengthCounter"
    >
        <ng-container hint>
            <p class="u-color-error u-margin-bottom-half" *ngIf="formControl.touched && formControl.invalid && !!question.invalidMessage">
                {{ question.invalidMessage | translateLabel }}
            </p>
            <p class="u-color-text" *ngIf="question.tip">
                <b>{{ 'SHARED.SURVEYS.TIP' | translate }}:</b> {{ question.tip | translateLabel }}
            </p>
        </ng-container>
    </app-textarea-input>
</div>
